<script lang="ts" setup>
import { buildMeta } from "~~/utils/meta-builder";

const i18n = useI18n();
const localePath = useLocalePath()
const config = useRuntimeConfig();
const emails = config.public.email;

// Privacy-E-Mail-Link wie in der normalen Privacy-Seite
const privacyEmail = `<a class="text-link hover:text-white" href="mailto:${emails.privacy}">${emails.privacy}</a>`

useHead(buildMeta({ key: "privacy-community", follow: false }));
</script>

<template>
  <div class="bg-primary-500">
    <Header theme="dark" />

    <div class="container main md:max-w-screen-md mx-auto text-white px-6 md:px-0">
      <!-- Header -->
      <div class="text-white py-20">
        <h1 class="font-bold text-3xl md:text-4xl font-owners">
          {{ $t("privacy-community.title") }}
        </h1>
        <p class="text-2xl py-4 font-light text-white/75">
          {{ $t("privacy-community.body") }}
        </p>

        <p class="text-lg pt-10 font-light text-white/75">
          {{ $t("privacy-community.date") }}
        </p>
        <p class="text-2xl py-4 font-light text-white/75">
          {{ $t("privacy-community.note") }}
        </p>

        <div class="pt-4">
          <NuxtLink
            :to="localePath('/privacy')"
            class="inline-flex items-center text-amber-400 underline hover:text-white transition-colors"
            :aria-label="$t('privacy-community.links.back_aria')"
          >
            ← {{ $t("privacy-community.links.back") }}
          </NuxtLink>
        </div>
      </div>

      <!-- Intro -->
      <div class="content-section">
        <div class="content-sticky-section">
          <h3 class="headline">
            {{ $t("privacy-community.intro.title") }}
          </h3>
        </div>
        <div class="content-body">
          <p class="pb-10 text-xl">
            {{ $t("privacy-community.intro.body") }}
          </p>
        </div>
      </div>

      <!-- Öffentliches Profil -->
      <div class="content-section">
        <div class="content-sticky-section">
          <h3 class="headline">
            {{ $t("privacy-community.profile.title") }}
          </h3>
        </div>
        <div class="content-body">
          <p class="pb-6 text-xl">
            {{ $t("privacy-community.profile.body") }}
          </p>
          <ul class="list-disc ml-2">
            <li
              v-for="item in $tm('privacy-community.profile.points')"
              :key="$rt(item as any)"
            >
              {{ $rt(item as any) }}
            </li>
          </ul>
        </div>
      </div>

      <!-- Inhalte -->
      <div class="content-section">
        <div class="content-sticky-section">
          <h3 class="headline">
            {{ $t("privacy-community.content.title") }}
          </h3>
        </div>
        <div class="content-body">
          <p class="pb-6 text-xl">
            {{ $t("privacy-community.content.body") }}
          </p>
          <ul class="list-disc ml-2">
            <li
              v-for="item in $tm('privacy-community.content.points')"
              :key="$rt(item as any)"
            >
              {{ $rt(item as any) }}
            </li>
          </ul>
        </div>
      </div>

      <!-- Rechtsgrundlage -->
      <div class="content-section">
        <div class="content-sticky-section">
          <h3 class="headline">
            {{ $t("privacy-community.legal.title") }}
          </h3>
        </div>
        <div class="content-body">
          <p class="pb-6 text-xl">
            {{ $t("privacy-community.legal.body") }}
          </p>
          <ul class="list-disc ml-2">
            <li
              v-for="item in $tm('privacy-community.legal.points')"
              :key="$rt(item as any)"
            >
              {{ $rt(item as any) }}
            </li>
          </ul>
        </div>
      </div>

      <!-- Risiken -->
      <div class="content-section">
        <div class="content-sticky-section">
          <h3 class="headline">
            {{ $t("privacy-community.risks.title") }}
          </h3>
        </div>
        <div class="content-body">
          <p class="pb-6 text-xl">
            {{ $t("privacy-community.risks.body") }}
          </p>
          <ul class="list-disc ml-2">
            <li
              v-for="item in $tm('privacy-community.risks.points')"
              :key="$rt(item as any)"
            >
              {{ $rt(item as any) }}
            </li>
          </ul>
        </div>
      </div>

      <!-- Kontrolle & Rechte -->
      <div class="content-section">
        <div class="content-sticky-section">
          <h3 class="headline">
            {{ $t("privacy-community.control.title") }}
          </h3>
        </div>
        <div class="content-body">
          <p class="pb-6 text-xl">
            {{ $t("privacy-community.control.body") }}
          </p>
          <ul class="list-disc ml-2">
            <li
              v-for="item in $tm('privacy-community.control.points')"
              :key="$rt(item as any)"
            >
              {{ $rt(item as any) }}
            </li>
          </ul>
        </div>
      </div>

      <!-- Kontakt -->
      <div class="content-section">
        <div class="content-sticky-section">
          <h3 class="headline">
            {{ $t("privacy-community.contact.title") }}
          </h3>
        </div>
        <div class="content-body">
          <p
            class="pb-10 text-xl"
            v-html="$t('privacy-community.contact.body', { 'privacy_email': privacyEmail })"
          ></p>

          <NuxtLink
            :to="localePath('/privacy')"
            class="inline-flex items-center text-amber-400 underline hover:text-white transition-colors"
            :aria-label="$t('privacy-community.links.back_aria')"
          >
            ← {{ $t("privacy-community.links.back") }}
          </NuxtLink>
        </div>
      </div>
    </div>

    <div class="bg-white">
      <Footer />
    </div>
  </div>
</template>
